import { render, staticRenderFns } from "./WatchButton.vue?vue&type=template&id=2432c466&scoped=true"
import script from "./WatchButton.vue?vue&type=script&lang=js"
export * from "./WatchButton.vue?vue&type=script&lang=js"
import style0 from "./WatchButton.vue?vue&type=style&index=0&id=2432c466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432c466",
  null
  
)

export default component.exports